import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
import { getUserFriendlyFailureMessage } from '../../../common/utils/errors';
import { useFieldErrorEventDispatch } from '../../../common/utils/events';
export var useFieldErrorState = function useFieldErrorState(fieldName) {
  var fieldErrorEventDispatch = useFieldErrorEventDispatch();
  var namedFieldErrorEventDispatch = useCallback(function () {
    return fieldErrorEventDispatch(fieldName);
  }, [fieldName, fieldErrorEventDispatch]);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      failureMessage = _useState2[0],
      setFailureMessage = _useState2[1];

  var setFailure = useCallback(function (failure) {
    setFailureMessage(function (oldFailureMessage) {
      if (oldFailureMessage !== undefined && failure !== undefined) {
        // Prefer old errors
        // but dont keep them if there is no error right now
        return oldFailureMessage;
      } else if (failure === undefined) {
        return undefined;
      }

      if (oldFailureMessage === undefined) {
        namedFieldErrorEventDispatch();
      }

      var userFriendlyMessage = getUserFriendlyFailureMessage(failure);
      return userFriendlyMessage !== undefined ? userFriendlyMessage : 'Unknown error';
    });
  }, [namedFieldErrorEventDispatch]);
  return {
    failureMessage: failureMessage,
    setFailure: setFailure
  };
};